import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const CheckboxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 375px;
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

const CustomCheckbox = styled.input.attrs({ type: 'checkbox' })`
  appearance: none;
  min-width: 20px;
  min-height: 20px;
  border: 1px solid
    ${({ showError, checked }) =>
      showError && !checked ? '#EF5C5C' : '#AEAEB4'};
  border-radius: 4px;
  background-color: #ffffff;
  transition: all 0.2s ease;
  cursor: pointer;

  &:checked {
    background-color: #00bfa5;
    border-color: #00bfa5;
    position: relative;

    &::after {
      content: url('/assets/welcome/check.svg');
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;

const Label = styled.label`
  font-size: 12px;
  color: #323232;
  margin-top: -1px;
  text-align: left;

  span {
    text-decoration: underline;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }
`;

const ErrorText = styled.div`
  margin: -10px 0px;
  font-size: 14px;
  line-height: 19px;
  text-align: left;
  color: #e55656;
  padding-left: 32px;
`;

const AppCheckboxes = ({
  isTermsChecked,
  onTermsChange,
  isUpdatesChecked,
  onUpdatesChange,
  showError,
  isCheckout = false,
}) => {
  const { t } = useTranslation();
  const onLinkClick = ({ target: { id } }) => {
    const links = {
      terms: 'https://geozilla.com/terms-of-use/',
      privacy: 'https://geozilla.com/privacy-policy/',
    };
    if (id && links[id]) window.open(links[id]);
  };
  return (
    <CheckboxWrapper>
      <CheckboxContainer>
        <CustomCheckbox
          checked={isTermsChecked}
          onChange={onTermsChange}
          showError={showError}
        />
        <Label
          dangerouslySetInnerHTML={{
            __html: t('welcome_disclaimer_v4'),
          }}
          onClick={(e) => onLinkClick(e)}
        />
      </CheckboxContainer>
      {isCheckout && showError && <ErrorText>{t('accept_terms')}</ErrorText>}
      <CheckboxContainer>
        <CustomCheckbox checked={isUpdatesChecked} onChange={onUpdatesChange} />
        <Label
          dangerouslySetInnerHTML={{
            __html: t('receive_updates'),
          }}
        />
      </CheckboxContainer>
    </CheckboxWrapper>
  );
};

export default AppCheckboxes;
